export default __webpack_public_path__ + "static/media/pp-12.6ca4cbbf.svg";